import { render, staticRenderFns } from "./DistributorDetails.vue?vue&type=template&id=5d1ca516&"
import script from "./DistributorDetails.vue?vue&type=script&lang=js&"
export * from "./DistributorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports